import produce from 'immer';
import { ReducerActionRotaSP } from 'store/modules/types';

// TYPES
import { Types, CadastrarUsuario } from './types';

export const INITIAL_STATE: CadastrarUsuario = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): CadastrarUsuario {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CADASTRAR_USUARIO_REQUEST: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.CADASTRAR_USUARIO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CADASTRAR_USUARIO_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.CADASTRAR_USUARIO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
